import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { MobileShell } from '../components/MobileShell';
import { TopBar } from '../components/TopBar';
import { ArrowLeft } from 'lucide-react';
import ProviderProducts from '../components/ProviderProducts';

export default function ProviderCatalogPage() {
  const { language } = useLanguage();
  return (
    <MobileShell>
      <TopBar
        showBrand={false}
        title={language === 'en' ? 'My Catalog' : 'Mi Catálogo'}
        right={
          <Link to="/dashboard" className="w-9 h-9 rounded-full flex items-center justify-center text-muted-foreground hover:bg-muted">
            <ArrowLeft size={18} />
          </Link>
        }
      />
      <div className="px-4 py-4" data-testid="provider-catalog-page">
        <ProviderProducts />
      </div>
    </MobileShell>
  );
}
